<template>
  <div :class="classes">
    <pt-page-title title="积分明细" :isSearch="true" @search="search" @emptySearch="emptySearch" :keyword="keyword"></pt-page-title>
    <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="filter">
      <template>
        <el-button type="primary" @click="filter()">统计</el-button>
        <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
        <el-button type="primary" @click="exportOldToNewAudit()" :loading="exportLoading">导出</el-button>
        <el-button type="primary" @click="exportHistoryOldToNewAudit">导出历史</el-button>
      </template>
    </pt-page-factor-filter>
    <p :class="$style['summary-tip']">
      <span>发放积分总计：</span>{{distribution }}
      <span>消费积分总计：</span>{{consume}}
    </p>
    <pt-integral-particulars-table @membersPointsSum="membersPointsSum" ref="table" :paramsData="paramsData" :tableLabel="tableLabels">
        <el-table-column label="操作"  fixed="right">
          <template v-if="scope.row.hasDetail" slot-scope="scope">
            <el-button type="text" @click="toDetail(scope.row.businessKey)">详情</el-button>
          </template>
        </el-table-column>
    </pt-integral-particulars-table>
  </div>
</template>

<script>
import { emptyObject } from '@/utils/lifebankUtils'
import { filterLabels, tableLabels } from './integral-particulars'
import ptIntegralParticularsTable from './pt-integral-particulars-table/withData'

// 组件class前缀
const prefixCls = 'pt-integral-particulars'
export default {
  name: 'pt-integral-particulars',
  components: { ptIntegralParticularsTable },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tableData () {
      return this.$refs.table.tableData
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    exportLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      filterLabels: filterLabels,
      tableLabels: tableLabels,
      paramsData: {},
      params: {},
      keyword: '',
      distribution: 0,
      consume: 0,
      pageSize: 10
    }
  },
  methods: {
    cleanParams () {
      emptyObject(this.params)
      this.filter()
    },
    search (val) {
      this.isFromRouter = false
      this.keyword = val
      emptyObject(this.paramsData)
      this.$set(this.paramsData, 'keyword', val)
    },
    emptySearch (val) {
      this.$delete(this.paramsData, 'keyword')
    },
    filter () {
      for (let key in this.params) {
        if (key === 'integralDate') {
          this.params = { ...this.params, ...this.params.integralDate }
          this.$delete(this.params, 'integralDate')
          this.$delete(this.params, 'index')
        }
      }
      for (let key2 in this.params) {
        if (!this.params[key2]) {
          this.$delete(this.params, key2)
        }
      }
      this.paramsData = { ...this.params }
    },
    // 导出列表
    exportOldToNewAudit () {
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          let params = { ...this.params }
          for (var key in params) {
            if (key === 'integralDate') {
              params = { ...params, ...params.integralDate }
              this.$delete(params, 'integralDate')
              this.$delete(params, 'index')
            }
          }
          for (var key2 in params) {
            if (!params[key2]) {
              this.$delete(params, key2)
            }
          }
          params.pageableParam = {
            page: this.page,
            size: this.pageSize,
            sort: ['createdDate,desc']
          }
          this.$emit('membersPointsDetailsExport', params)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    exportHistoryOldToNewAudit () {
      this.$router.push('/export-history/integral-particulars?name=points_details_export')
    },
    // 获取积分统计
    membersPointsSum (val) {
      this.$store.dispatch('membersPointsSum', val).then(res => {
        this.distribution = res.distribution
        this.consume = res.consume
      }).catch(err => {
        this.$message.error(err || '获取积分统计失败')
      })
    },
    toDetail (val) {
      this.$router.push('/integral-exchange-detail/' + val + '/detail')
    }
  }
}
</script>

<style module lang="less">
@import '~less/var.less';
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.summary-tip{
    text-align: right;
    font-size: 30px;
    color:#606266;
    span{
      font-size: 20px;
      color:@mainColor;
      font-weight: 800;
      padding-left:50px;
    }
  }
</style>
